import * as React from 'react';
import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { observer } from 'mobx-react';
import { AnimatePageWidget } from '../../../widgets/layout/AnimatePageWidget';
import { useSystem } from '../../../hooks/useSystem';
import { GroupHeaderWidget } from './GroupHeaderWidget';
import { AboutSectionWidget } from '../../../widgets/pages/AboutSectionWidget';
import styled from '@emotion/styled';

export const GroupPage: React.FC = observer(() => {
  const system = useSystem();
  const params = useParams<{ id: string }>();
  const group = system.group_store.getModel(params.id);

  useEffect(() => {
    group.refresh();
  }, [group]);

  if (!group.data) {
    return null;
  }

  return (
    <AnimatePageWidget slide={true}>
      <GroupHeaderWidget group={group} />
      <S.Section>
        <AboutSectionWidget model={group} />
      </S.Section>
    </AnimatePageWidget>
  );
});

namespace S {
  export const Section = styled.div`
    padding: 20px;
  `;
}
